import { createFileRoute } from "@tanstack/react-router";
import RelistListing from "@/pages/RelistListing";

export const Route = createFileRoute("/relist/$listingId/")({
  head: () => ({
    meta: [
      { title: "Prelungește anunțul | RO Auto Market" },
      { name: "description", content: "Reactivează anunțul tău auto păstrând același link, aceleași statistici și aceeași vechime." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "Prelungește anunțul | RO Auto Market" },
      { property: "og:description", content: "Reactivează anunțul tău auto în câțiva pași, cu același link public." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RelistListing />;
}
